import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { storyDataArrayProps } from "../containers/WebStoryScreen/types";

interface StoryState {
  storyData: storyDataArrayProps | null;
  storyId: string | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: StoryState = {
  storyData: null,
  storyId: null,
  isLoading: false,
  error: null,
};

const storySlice = createSlice({
  name: "story",
  initialState,
  reducers: {
    setStoryData(state, action: PayloadAction<storyDataArrayProps>) {
      state.storyData = action.payload;
      state.storyId = action.payload.storyId ?? null;
      state.error = null;
    },
    clearStoryData(state) {
      state.storyData = null;
      state.storyId = null;
      state.error = null;
    },
    setStoryLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setStoryError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setStoryData, clearStoryData, setStoryLoading, setStoryError } =
  storySlice.actions;

export default storySlice.reducer;
